// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"landing-page_wrapper__q5meD","container":"landing-page_container__RFn2E"};